// extracted by mini-css-extract-plugin
export var productImage = "_ze-0";